import styled from 'styled-components'

type Props = {
	showTopBorder: boolean
}

export const Container = styled.div<Props>`
	display: flex;
	flex-direction: column;
	margin-bottom: 16px;

	border-top: ${({ showTopBorder, theme }) => (showTopBorder ? `1px solid ${theme.color.separator}` : null)};
`
